import React from "react";
import { ShieldAlert, LogOut, Clock, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { YaprioLogo } from "@/components/YaprioLogo";

export default function BannedScreen({ ban, ipBan = false }) {
  const { logout, refresh } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAFAFB] px-4" data-testid="banned-screen">
      <div className="w-full max-w-md rounded-3xl border border-slate-100 bg-white p-8 shadow-xl">
        <div className="mb-6 flex justify-center">
          <YaprioLogo />
        </div>
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50">
          <ShieldAlert className="h-7 w-7 text-red-500" />
        </div>
        <h1 className="text-center font-heading text-2xl font-extrabold text-slate-900">{ipBan ? "This network is blocked" : "Your account is suspended"}</h1>
        <p className="mt-2 text-center text-sm text-slate-500">
          {ipBan ? "This network has been blocked by Yaprio moderation. You can&apos;t enter or use Yaprio from this network." : "A Yaprio moderator has restricted this account. You can&apos;t chat, message, call or add friends while the suspension is active."}
        </p>

        <div className="mt-6 space-y-3 rounded-2xl border border-slate-100 bg-slate-50 p-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Reason</p>
            <p className="mt-1 break-words text-sm font-medium text-slate-700" data-testid="ban-reason-text">
              {ban?.reason || "Violation of the community rules."}
            </p>
          </div>
          <div className="flex items-center gap-2 border-t border-slate-200/70 pt-3 text-sm text-slate-600">
            <Clock className="h-4 w-4 shrink-0 text-slate-400" />
            <span data-testid="ban-expiry-text">
              {ban?.expires_at
                ? `Expires ${new Date(ban.expires_at).toLocaleString()}`
                : "This block is permanent."}
            </span>
          </div>
        </div>

        {!ipBan && <div className="mt-6 flex flex-col gap-2">
          <Button
            variant="outline"
            onClick={() => refresh()}
            data-testid="ban-recheck-btn"
            className="w-full rounded-full border-slate-200"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Check status again
          </Button>
          <Button
            onClick={logout}
            data-testid="ban-signout-btn"
            className="w-full rounded-full bg-slate-900 text-white hover:bg-slate-800"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </Button>
        </div>}
      </div>
    </div>
  );
}
